/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const removeIncorrectTracksCommandSchema = z.object({
    
    })